import React from "react";
import styles from "./FlagIcon.module.css";

interface FlagIconProps {
  countryCode: string;
  size?: "small" | "medium" | "large";
  alt?: string;
}

export const FlagIcon: React.FC<FlagIconProps> = ({
  countryCode,
  size = "medium",
  alt,
}) => {
  const flagCode = countryCode.toLowerCase();

  const sizeMap = {
    small: "24x18",
    medium: "32x24",
    large: "48x36",
  };

  const flagSize = sizeMap[size];
  const flagUrl = `https://flagcdn.com/${flagSize}/${flagCode}.png`;

  const sizeClasses = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
  };

  return (
    <img
      src={flagUrl}
      alt={alt || `Flag of ${countryCode}`}
      className={`${styles.flagIcon} ${sizeClasses[size]}`}
      loading="lazy"
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.style.display = "none";
      }}
    />
  );
};
